import { Config } from '../classes/Config';

export class Log {

  private logMaxSize = 10;
  private logHistory: string[] = [];

  private static instance: Log = new Log();

  public static getInstance() {
    return this.instance;
  }

  private getCircularReplacer() {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  }

  private getTimestamp(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  public d(something: any) {

    const timestamp = this.getTimestamp();

    //If the array already contains 5 elements, just keep the 4 last ones
    if (this.logHistory.length === this.logMaxSize) {
      this.logHistory = this.logHistory.slice(1); // Simplified slice
    }

    if (something != null) {
      let stringified = JSON.stringify(something, this.getCircularReplacer(), 4);
      if (stringified && stringified !== "{}") {
        if(stringified.length > 1500) {
          stringified = stringified.substr(0, 1500).concat(" (*truncated by frontend*)");
        }
        this.logHistory.push(`${timestamp}: ${stringified}`); // Add timestamp to log entry
      }
    }

    if (Config.isProd === false)
    {
      console.log(`${timestamp}:`, something); // Also log with timestamp to the console
    }
  }

  public e(something: any) {
    const timestamp = this.getTimestamp();
    if (Config.isProd === false) {
      console.error(`${timestamp}:`, something); // Also log with timestamp to the console
    }
  }

  public getLogHistory(): string[] {
    return this.logHistory;
  }

}
